<svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
	<mask
		id="mask0_1090_11166"
		style="mask-type:alpha"
		maskUnits="userSpaceOnUse"
		x="0"
		y="0"
		width="45"
		height="45"
	>
		<rect width="45" height="45" fill="#D9D9D9" />
	</mask>
	<g mask="url(#mask0_1090_11166)">
		<path
			d="M22.5 41.5949C18.1562 40.4984 14.5706 37.9996 11.7431 34.0985C8.91438 30.1986 7.5 25.8677 7.5 21.1057V9.63924L22.5 4L37.5 9.63924V21.1057C37.5 25.8677 36.0863 30.1986 33.2588 34.0985C30.43 37.9996 26.8438 40.4984 22.5 41.5949ZM22.5 18.1451L12 26.322C12.5938 28.2957 13.4688 30.089 14.625 31.7018C15.7812 33.3159 17.1562 34.6712 18.75 35.7677V28.4367H26.25V35.7677C27.8438 34.6712 29.2188 33.3159 30.375 31.7018C31.5313 30.089 32.4062 28.2957 33 26.322L22.5 18.1451ZM22.5 7.99446L11.25 12.2239V21.1057C11.25 21.2623 11.2581 21.4346 11.2744 21.6226C11.2894 21.8106 11.2969 21.9829 11.2969 22.1395L22.5 13.3987L33.7031 22.1395C33.7031 21.9829 33.7113 21.8106 33.7275 21.6226C33.7425 21.4346 33.75 21.2623 33.75 21.1057V12.2239L22.5 7.99446Z"
			fill="#004860"
		/>
	</g>
</svg>
